import { showFontPreview } from './fonts/fontPreview';
import { IWindowDevTool, registerWindowDevTools } from './windowDevTools';

export const DEFAULT_WINDOW_DEV_TOOLS: ReadonlyArray<IWindowDevTool> = [
    {
        name: 'showFontPreview',
        run: showFontPreview,
        hotkey: { ctrl: true, shift: true, key: 'f' },
    },
];

export const registerDefaultWindowDevTools = (): (() => void) =>
    registerWindowDevTools(DEFAULT_WINDOW_DEV_TOOLS);
